const API_BASE_URL = 'https://virtserver.swaggerhub.com/PetrGraf/Efed/0.1.0';

const createFetchInstance = () => {
    let authToken: string | null = null;
    return {
        setAuthToken: (token: string) => {
            authToken = token;
        },
        fetch: (input: string, init?: RequestInit | undefined) => {
            return fetch(API_BASE_URL + input, init);
        },
        fetchWithAuthToken: (input: string, init?: RequestInit | undefined) => {
            if (!authToken) {
                throw new Error('Missing authToken, make sure to login to API first');
            }
            return fetch(API_BASE_URL + input, {
                ...init,
                headers: {
                    bearerAuth: authToken,
                },
            });
        },
    };
};

export default createFetchInstance();
